import { render, staticRenderFns } from "./PageOutIns.vue?vue&type=template&id=643bc6f6&scoped=true&"
import script from "./PageOutIns.vue?vue&type=script&lang=js&"
export * from "./PageOutIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643bc6f6",
  null
  
)

export default component.exports